import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_661ovrgbd0: FaireBrandEntity = {
  token: "b_661ovrgbd0",
  type: "brand",
  name: "Papillon Bebe",
  avatarUrl:
    "https://cdn.faire.com/fastly/d9f88219d3ac27417757d9470ce51d33108556f4bf1efe83071faf4d9bc4fd66.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7a0708b44d35d31ebba5c3b0fc8722646bbf960968e421a695ec9b6148f02e8d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d9f88219d3ac27417757d9470ce51d33108556f4bf1efe83071faf4d9bc4fd66.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7a0708b44d35d31ebba5c3b0fc8722646bbf960968e421a695ec9b6148f02e8d.jpeg",
  location: "Lindon, UT, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 178,
  isInsider: true,
  description:
    'Papillon Bebe creates and designs modern baby products to help moms provide the best possible care for their little ones.  From our fashionable top & bottom sets to our pillow loungers, we provide modern style with functionality to help mom and baby have the best experience possible. \n\nOUR STORY\nOur founder, Shannon, was diagnosed with a terminal brain tumor and told she had only a few short months to live. She was also told her creativity would be the first thing to go.  Shannon refused to give up and simply accept what the doctors had told her.  She decided to fight for as long as she could and use her creativity.  Shannon ultimately lived for almost four additional years and during that time created Papillon Bebe.\n\nTo Shannon, Papillon Bebe represents trusting in the highest source and planning for the future. It represents creation and new beginnings. Papillon Bebe which is French for "butterfly baby" represents the miracle of being reborn and the symbolic transformation into a butterfly. She was so grateful to share what she created and with the time she had to watch it transform into something beautiful.\n\nWe hope you and your customers enjoy the beautiful items Shannon created.\n',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:38.194Z",
    importedBy: "entity-db-cli",
  },
};
